import React from 'react';
import PropTypes from 'prop-types';
import Comment from 'assets/icons/Comment';
import LoadingCircle from 'assets/icons/LoadingCircle';

import { useConversation } from 'hooks/useConversation/useConversation';
import { useTranslation } from 'react-i18next';

const SupportButton = ({ className, journeyId }) => {
  const {
    handleCreateConversation,
    checksIfHasConversationAndReturnId,
    handleFetchAndGoToConversation,
    loading
  } = useConversation();
  const { t } = useTranslation('Chat');
  const conversationId = checksIfHasConversationAndReturnId(journeyId);

  const handleClick = () => {
    if (conversationId) {
      handleFetchAndGoToConversation(conversationId, 'Support button');
    } else {
      handleCreateConversation(`J${journeyId}`, journeyId, 'Support button');
    }
  };

  return (
    <div className={className} data-testid="support-button">
      <div className="support-button">
        <button
          className="support-button__button"
          onClick={handleClick}
          disabled={loading}
          data-testid="support-button__button"
        >
          <div className="support-button__container">
            {!loading && <Comment className="support-button__icon" />}
            {loading && (
              <LoadingCircle
                className="support-button__icon support-button__icon--loading"
                data-testid="support-button__loading-icon"
              />
            )}
            <span className="support-button__text">{t('support')}</span>
          </div>
        </button>
      </div>
    </div>
  );
};
SupportButton.propTypes = {
  className: PropTypes.string,
  journeyId: PropTypes.number.isRequired
};
export default SupportButton;
